import { CampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type SaveCampaignResponse = {
    result: string;
}

type UseSaveCampaignChangesResponse = [
    (data: CampaignObject) => Promise<SaveCampaignResponse | null>,
    {
        value?: SaveCampaignResponse;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useSaveCampaignChanges = (): UseSaveCampaignChangesResponse => {
    
    const [post, postState] = usePost<SaveCampaignResponse, CampaignObject>({
        url: `campaign/update-campaign`
    })

    const saveChanges = async (
        data : CampaignObject
    ) : Promise<SaveCampaignResponse | null> => {

        const result = await post(data);
        return result;
    }

    return [saveChanges, postState];
};